module.exports = function() {
  return new Worker(__webpack_public_path__ + "fca5d65f9edf96ade230.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/es5/build/pdf.worker.js
// module id = yQBj
// module chunks = 0